import React, { Fragment, useEffect, useState, useRef } from "react";
import getEventosPartidos from "services/getEventos.js"
import CardPartidosEnvivo from "../card-partidos-envivo/card-partidos-envivo.js";
import Loading from "components/loading/loading";
import SinResultados from "components/sinResultados/sinResultados.js";
import "./listado-partidos-envivo.sass";


export default function ListadoPartidosEnvivo({ seccion, ligaFut, showFilter }) {
    const [dataEventos, setDataEventos] = useState([]);
    const [error, setError] = useState(false);
    const [showLoading, setShowLoading] = useState(true);
    const [liga,] = useState(ligaFut);
    const [dataTipos, setDataTipos] = useState(false);
    const [valorFiltroTipo, setValorFiltroTipo] = useState(false);

    // console.log(" props seccion =", seccion,  " showfilter: ", showFilter)
    // console.log(" data: ", dataEventos)
    // console.log(" tipos: ", dataTipos)

    // peticion al servicio para obtener los partidos
    useEffect(() => {
        if (liga) {
            setShowLoading(true);
            getEventos(liga);

            // intervalo para ejecutar la función cada 15 minutos
            const intervalId = setInterval(() => {
                getEventos(liga);
            }, 900000);

            // eliminarel intervalo cuando el componente se desmonte o cambie la variable seccion
            return () => {
                clearInterval(intervalId);
            };

        }
    }, [liga])

    // solicitud para traer el listado de partidos
    const getEventos = async (liga) => {
        try {
            const eventos = await getEventosPartidos(liga);

            if (eventos && eventos.statusCode === 200) {

                setDataEventos(eventos.data);

            } else if (eventos && eventos.statusCode === 404) {
                setError(true);
                setDataEventos([]);
            }
        } catch (e) {
            setError(true);
        } finally {
            setShowLoading(false);
            setError(false);
        }
    };


    //________________ FUNCIONAMIENTO DE FILTRADO POR TIPO_________________
    const filtrarEventos = (eventos) => {
        if (showFilter === '2') {
            return eventos.filter(evento => evento.type === 'video');
        }else if(showFilter === '3') {
            return eventos.filter(evento => evento.type === 'imagen');

        }else {
            return eventos; // Si showfilter no es true, retorna todos los eventos
        }
    };
    //________________ FIN FUNCIONAMIENTO DE FILTRADO _________________




    //------- INICIAR EJECUCION DE REZISE DEL COMPONENTE -------
    const envivoRef = useRef(null);

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                const newHeight = entry.contentRect.height;

                window.requestAnimationFrame(() => {
                    const message = {
                        sentinel: "amp",
                        type: "embed-size",
                        height: newHeight,
                    };
                    window.parent.postMessage(message, "*");
                });
            });
        });

        if (envivoRef.current) {
            resizeObserver.observe(envivoRef.current);
        }

        // Limpia el ResizeObserver al desmontar el componente
        return () => {
            resizeObserver.disconnect();
        };
    }, [envivoRef]);
    //------- TERMINA EJECUCION DE REZISE DEL COMPONENTE -------

    return (
        <div ref={envivoRef} className={!showLoading && !error && dataEventos && (dataEventos.length === 0 || filtrarEventos(dataEventos).length === 0) ? "container-p" : ""}>
            {/* seccion loading */}
            {showLoading && (<Loading />)}

            <>
                {/* seccion sin resultados  */}
                {!showLoading && !error && dataEventos && (dataEventos.length === 0 || filtrarEventos(dataEventos).length === 0)
                    ? <SinResultados componenteActual={seccion} />
                    : !showLoading && dataEventos && dataEventos.length !== 0 &&
                    <div className="envivo-component-listado colorL1">
                        <div className={"container-general-listadoSuperior gridPar"}>
                            {dataEventos && dataEventos.length !== 0 &&
                                filtrarEventos(dataEventos).map((item, indice) =>
                                    <Fragment key={indice}>
                                        <CardPartidosEnvivo
                                            imagen={item.image}
                                            titulo={item.title}
                                            horaInicio={item.utc_date}
                                            enlace={item.url}
                                            tipo={String(item.type).toLowerCase()}
                                        />
                                    </Fragment>
                                )
                            }
                        </div>
                    </div>
                }
            </>
        </div>
    )
}